import {
  PREDICT_PRODUCT_SLUG,
  getProductUrl,
  interpolatePathParams,
  joinRouteMatchPath,
  ROUTES
} from '@futrli/shared-services';

export function getRedirectURL(
  workspaceId: string,
  organisationId: string,
  forecastId: string,
  redirectPath: string,
  queryParams?: string
) {
  const productURL = getProductUrl(workspaceId, organisationId, PREDICT_PRODUCT_SLUG);
  const basePath = joinRouteMatchPath('', ROUTES.FORECASTS, ROUTES.FORECAST_BY_ID, redirectPath);
  const exportPath = interpolatePathParams(basePath, { forecastId });
  return `${window.location.origin}${productURL}${exportPath}${queryParams || ''}`;
}
